import React, { useState } from "react";
import { IconButton } from "@mui/material";
import classes from "../../css/modules/navigation.module.scss";
import { PageTitle } from "./PageTitle";
import { Link } from "react-router-dom";
import { routes } from "../../utils/constants";
import clsx from "clsx";
import { MenuContent } from "./MenuContent";
import { HelpButton } from "../HelpButton";

export const Header = () => {
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);

  const toggle = () => setSidebarIsOpen(!sidebarIsOpen);
  const onLocationChange = () => {
    setSidebarIsOpen(false);
  };

  return (
    <>
      <header className={classes.header}>
        <IconButton
          className={classes.burgerMenu}
          onClick={toggle}
          edge="start"
          color="inherit"
          aria-label="menu"
          data-testid="mn_menu_icon"
        >
          <span
            className={clsx({
              ico: true,
              "icon-menu": !sidebarIsOpen,
              "icon-cross": sidebarIsOpen,
            })}
          ></span>
        </IconButton>
        <Link to={routes.projects} className={classes.headerTitle}>
          <img src={"/logo.jpg"} alt="Logo" height="29" />
        </Link>
        <PageTitle />
        <HelpButton/>
      </header>
      <div className={clsx(classes.sidebarDrawer, sidebarIsOpen && classes.open)} data-testid="mn_menu_sidebar">
        <MenuContent onLocationChange={onLocationChange} />
      </div>
    </>
  );
};
